import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { withNavigation } from '../../../General/withNavigation';
import {
    postAprobarPublicacionApi,
    postDesaprobarPublicacionApi,
    updatePublicacionEstadoBulkApi
} from '../../../../api/axios'
import { fetchPublicacion, editPublicacion, updateListPublicaciones } from '../../../../actions/publicacionesActions';
import { toast } from '../../../../utilities/appToast';
import { getIdEstadoPublicacion } from '../../../../helper/publicacionHelper';
import StatusTimeline from '../../../General/StatusTimeline';
import { buildPublicationTimeline } from '../../../../helper/statusTimelineHelper';
import PropTypes from 'prop-types';
import { switchClassEstado } from '../../../../utilities/ABMPublicacion/switchClassEstado';
import { BtnPausarModerador, BtnAprobarModerador, BtnPublicarSeller, BtnPausarSeller } from './BotonesEstado';

// Wrapper para usar hooks en class component
function EstadoWrapper(props) {
  const navigate = useNavigate();
  return <Estado {...props} navigate={navigate} />;
}

class Estado extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            estado: this.props.publicacion.estado,
        };
    }

    handleChange = (event) => {
        event.preventDefault();
        let publicacion = { ...this.props.publicacion };
        publicacion[event.target.name] = event.target.value;
        this.props.editPublicacion(publicacion);
    }

    setEstado = (event) => {
        event.preventDefault();
        const { userType } = this.props;
        let publicacion = { ...this.props.publicacion };
        publicacion.estado = event.target.name;

        if ((userType.isAdminMod || userType.isCategory) && publicacion.estado === "activo") {
            const reqAprobar = postAprobarPublicacionApi({ idPublicacion: this.props.publicacion.idPublicacion });
            reqAprobar.then(res => {
                this.props.editPublicacion(publicacion);
                toast.success("Publicación aprobada");
                this.setState({ estado: publicacion.estado })

            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo aprobarse");
            });
        } else if (userType.isAdminMod || userType.isCategory) {
            const reqDesaprobar = postDesaprobarPublicacionApi({ IdPublicacion: this.props.publicacion.idPublicacion });

            reqDesaprobar.then(res => {
                this.props.editPublicacion(publicacion);
                toast.success("Publicación desaprobada");
                this.setState({ estado: publicacion.estado })

            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo desaprobarse");
            });

        //si entro con un seller
        } else {
                this.updateEstado(publicacion);
        }
    }

    updateEstado = async (publicacion) => {
        const idEstado = getIdEstadoPublicacion(publicacion.estado);

        const payload = {
            cambiarEstadoPublicacionesBulks: [{
                idPublicaciones: publicacion.idPublicacion,
                estados: idEstado
            }],
            idUser: this.props.userId
        };

        try {
            await updatePublicacionEstadoBulkApi(payload);
            toast.success("Estado editado");

            //si el estado de la publicacion cambia, llamo al editPublicacion del store y update la lista
            this.props.editPublicacion(publicacion);
            this.props.updateListPublicaciones(this.props.publicaciones, publicacion);
        } catch (err) {
            if (err.response?.data?.errors) {
                err.response.data.errors.forEach(error => toast.error(error.errorMesage));
            } else {
                toast.error("No se pudo editar el estado");
            }
        }
    };

    render() {
        const { isCategory, isAdminMod } = this.props.userType;
        const { publicacion, motivosRevision, inCreate } = this.props;
        const { estado } = this.state;
        const timelineItems = buildPublicationTimeline(publicacion, motivosRevision);

        let motivosDeRevisionOptions = null;
        if (motivosRevision != null) {
            motivosDeRevisionOptions = motivosRevision.map((motivo, index) => {
                return <option key={motivo.codigo} value={motivo.codigo}>{motivo.descripcion}</option>
            });
        }

        let codigoMotRevision = null;
        if (motivosRevision !== undefined) {
            if (motivosRevision.at(-1) !== undefined) {
                codigoMotRevision = motivosRevision.at(-1).codigo;
            }
        }

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <StatusTimeline
                    title="Estado de la publicacion"
                    subtitle="Recorrido del flujo comercial"
                    items={timelineItems}
                />

                <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-8">

                        <div className="form-group">
                            <div className="d-flex">
                                <div className="mr-auto p-2">
                                    <span className={`label p-10 text-uppercase ${switchClassEstado(publicacion.estado)}`}>{estado}</span>
                                </div>
                                <div className="p-2 d-none d-lg-block">
                                    <BtnPublicarSeller estado={estado} inCreate={inCreate} setEstado={this.setEstado} isAdminMod={isAdminMod} isCategory={isCategory} />
                                    <BtnPausarSeller estado={estado} inCreate={inCreate} setEstado={this.setEstado} isAdminMod={isAdminMod} isCategory={isCategory} />
                                    <BtnAprobarModerador estado={estado} setEstado={this.setEstado} isAdminMod={isAdminMod} isCategory={isCategory} />
                                    <BtnPausarModerador estado={estado} setEstado={this.setEstado} isAdminMod={isAdminMod} isCategory={isCategory} />
                                </div>
                            </div>
                        </div>

                        <div className="form-group" hidden={publicacion.estado === "activo"}>
                            <label htmlFor="inlineFormCustomSelect">Motivo</label>
                            <select
                                className=" form-control col-12"
                                disabled={publicacion.estado !== "en_revision" || (!isCategory && !isAdminMod)}
                                value={publicacion.idMotivoRevision}
                                onChange={this.handleChange}
                                id="inlineFormCustomSelect"
                                name="idMotivoRevision"
                            >
                                {motivosDeRevisionOptions}
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="operadorEstado">Operador</label>
                            <input id="operadorEstado" type="text" className="form-control" disabled name="precioLista" />
                        </div>

                        <div className="form-group">
                            <label htmlFor="fechaHoraEstado">Fecha Hora</label>
                            <input
                                id="fechaHoraEstado"
                                type="text"
                                className="form-control"
                                disabled
                                value={publicacion.fechaUltimaModificacion}
                                name="fecha"
                            />
                        </div>

                        <div
                            className="form-group"
                            hidden={publicacion.idMotivoRevision !== codigoMotRevision || publicacion.estado === "activo"}
                        >
                            <label htmlFor="exampleFormControlTextarea1">Comentario</label>
                            <textarea
                                name="observacionesRevision"
                                disabled={!isCategory && !isAdminMod}
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                onChange={this.handleChange}
                                rows="3"
                                value={publicacion?.observacionesRevision ?? ""}
                            />
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
Estado.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        state: PropTypes.shape({
            pathReturn: PropTypes.string,
        }),
    }),
    // Redux props
    publicacion: PropTypes.shape({
        estado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        idPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        idMotivoRevision: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        fechaUltimaModificacion: PropTypes.string,
        observacionesRevision: PropTypes.string,
    }),
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
        isCategory: PropTypes.bool,
    }),
    userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    publicaciones: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        publicaciones: PropTypes.array,
    })]),
    motivosRevision: PropTypes.array,
    inCreate: PropTypes.bool,
    // Actions props
    editPublicacion: PropTypes.func,
    updateListPublicaciones: PropTypes.func,
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    publicacion: state.publicaciones.publicacion,
    varciaciones: state.publicaciones.variacionesPublicacion,
    motivosRevision: state.publicaciones.motivosRevision,
    userId: state.general.userId,
    publicaciones: state.publicaciones.publicaciones,
});

export default withNavigation(connect(mapStateToProps, { fetchPublicacion, editPublicacion, updateListPublicaciones })(EstadoWrapper));
